/* ============================================================
   Buono Joyas — Comportamiento del PDP (página de producto)
   ------------------------------------------------------------
   - Galería: miniaturas + zoom al mover el cursor
   - Selector de variantes (precio/cuotas/disponibilidad precalculados
     en Liquid → sin asumir moneda; solo intercambia strings)
   - Cantidad, regalo (propiedad de línea), urgencia ilustrativa
   - Add-to-cart usa el <product-form-component> real de Horizon
   Idempotente para el editor de temas.
   ============================================================ */
(function () {
  'use strict';

  function initGallery(root) {
    var stage = root.querySelector('[data-buono-stage]');
    if (!stage) return;
    var thumbs = root.querySelectorAll('[data-buono-thumb]');

    function setMedia(thumb) {
      var type = thumb.getAttribute('data-media-type');
      var full = thumb.getAttribute('data-full');
      var alt = thumb.getAttribute('data-alt') || '';
      if (!full) return;
      var badge = stage.querySelector('[data-buono-badge]');
      var media;
      if (type === 'video') {
        stage.style.cursor = 'default';
        media = document.createElement('video');
        media.autoplay = true; media.muted = true; media.loop = true;
        media.playsInline = true; media.setAttribute('playsinline', '');
        media.src = full;
      } else {
        stage.style.cursor = 'zoom-in';
        media = document.createElement('img');
        media.setAttribute('data-buono-stage-img', '');
        media.src = full;
        media.alt = alt;
      }
      stage.textContent = '';
      if (badge) stage.appendChild(badge);
      stage.appendChild(media);
      thumbs.forEach(function (t) { t.classList.remove('is-on'); });
      thumb.classList.add('is-on');
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setMedia(t); });
    });

    stage.addEventListener('mousemove', function (e) {
      var img = stage.querySelector('img');
      if (!img) return;
      var r = stage.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width * 100;
      var y = (e.clientY - r.top) / r.height * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(2.1)';
    });
    stage.addEventListener('mouseleave', function () {
      var img = stage.querySelector('img');
      if (!img) return;
      img.style.transformOrigin = 'center';
      img.style.transform = 'scale(1)';
    });
  }

  /* Carrusel deslizable en mobile: se CONSTRUYE desde las miniaturas (data-full
     ya trae la imagen a 1200px), por eso no requiere cambios en el .liquid.
     El CSS lo muestra solo en mobile y oculta miniaturas + stage. */
  function initGalleryScroller(root) {
    var gallery = root.querySelector('.buono-gallery');
    if (!gallery || gallery.querySelector('[data-buono-scroller]')) return;
    var thumbs = root.querySelectorAll('[data-buono-thumb]');
    if (thumbs.length < 2) return;

    var scroller = document.createElement('div');
    scroller.className = 'buono-gallery__scroller';
    scroller.setAttribute('data-buono-scroller', '');

    /* Clona el badge (descuento / etiqueta) para que se vea sobre el carrusel */
    var badge = root.querySelector('[data-buono-badge]');
    if (badge && badge.children.length) scroller.appendChild(badge.cloneNode(true));

    thumbs.forEach(function (thumb) {
      var full = thumb.getAttribute('data-full');
      if (!full) return;
      var slide = document.createElement('div');
      slide.className = 'buono-slide';
      var media;
      if (thumb.getAttribute('data-media-type') === 'video') {
        media = document.createElement('video');
        media.src = full; media.autoplay = true; media.muted = true;
        media.loop = true; media.playsInline = true;
        media.setAttribute('playsinline', '');
      } else {
        media = document.createElement('img');
        media.src = full;
        media.alt = thumb.getAttribute('data-alt') || '';
        media.loading = 'lazy';
      }
      slide.appendChild(media);
      scroller.appendChild(slide);
    });

    var slides = scroller.querySelectorAll('.buono-slide');
    if (slides.length < 2) return;

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'buono-gallery__dots';
    dotsWrap.setAttribute('data-buono-dots', '');

    gallery.appendChild(scroller);
    gallery.appendChild(dotsWrap);

    var dots = [];
    slides.forEach(function (slide, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'buono-dot' + (i === 0 ? ' is-on' : '');
      d.setAttribute('aria-label', 'Ir a imagen ' + (i + 1));
      d.addEventListener('click', function () {
        scroller.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(d);
      dots.push(d);
    });

    var ticking = false;
    scroller.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var pos = scroller.scrollLeft, idx = 0, min = Infinity;
        slides.forEach(function (s, i) {
          var dist = Math.abs(s.offsetLeft - pos);
          if (dist < min) { min = dist; idx = i; }
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
      });
    }, { passive: true });
  }

  function initVariants(root) {
    var dataEl = root.querySelector('[data-buono-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var selected = {};
    root.querySelectorAll('[data-buono-opt].is-on').forEach(function (b) {
      selected[b.getAttribute('data-opt-pos')] = b.getAttribute('data-opt-value');
    });

    var idInput = root.querySelector('[data-buono-variant-id]');
    var priceNow = root.querySelector('[data-buono-price]');
    var priceWas = root.querySelector('[data-buono-was]');
    var priceSave = root.querySelector('[data-buono-save]');
    var cuota = root.querySelector('[data-buono-cuota]');
    var addBtn = root.querySelector('[data-buono-add]');

    function findVariant() {
      if (variants.length === 1) return variants[0];
      return variants.find(function (v) {
        return (v.options || []).every(function (val, idx) {
          return selected[idx + 1] === val;
        });
      });
    }

    function update() {
      var v = findVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable-label') || 'No disponible'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.innerHTML = v.price_f;
      if (priceWas) {
        if (v.on_sale) { priceWas.innerHTML = v.compare_f; priceWas.hidden = false; }
        else { priceWas.hidden = true; }
      }
      if (priceSave) {
        if (v.on_sale && v.save_f) { priceSave.innerHTML = v.save_f; priceSave.hidden = false; }
        else { priceSave.hidden = true; }
      }
      if (cuota) cuota.innerHTML = v.cuota_f;
      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-add-label') || 'Agregar a la bolsa';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-soldout-label') || 'Agotado';
        }
      }
    }

    root.querySelectorAll('[data-buono-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-opt-pos');
        var val = btn.getAttribute('data-opt-value');
        selected[pos] = val;
        root.querySelectorAll('[data-buono-opt][data-opt-pos="' + pos + '"]').forEach(function (b) {
          b.classList.remove('is-on');
        });
        btn.classList.add('is-on');
        var lbl = root.querySelector('[data-buono-opt-label="' + pos + '"]');
        if (lbl) lbl.textContent = val;
        update();
      });
    });

    update();
  }

  function initQty(root) {
    var input = root.querySelector('[data-buono-qty-input]');
    if (!input) return;
    var dec = root.querySelector('[data-buono-qty="-1"]');
    var inc = root.querySelector('[data-buono-qty="1"]');
    function set(n) { input.value = Math.max(1, n); }
    if (dec) dec.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
    if (inc) inc.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
  }

  function initGift(root) {
    var check = root.querySelector('[data-buono-gift]');
    var note = root.querySelector('[data-buono-giftnote]');
    if (check && note) {
      check.addEventListener('change', function () { note.hidden = !check.checked; });
    }
    /* Desactiva las propiedades de línea vacías SOLO al enviar (para no mandar
       "Grabado:" o "Dedicatoria:" vacías al carrito). NO se deshabilitan antes,
       si no el campo queda disabled y no se puede escribir. */
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      var props = form.querySelectorAll('[data-buono-prop]');
      form.addEventListener('submit', function () {
        props.forEach(function (el) {
          el.disabled = (el.value || '').trim() === '';
        });
      }, true);
    }
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-buono-sticky]');
    var actions = root.querySelector('.buono-actions');
    if (!bar || !actions) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var aboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', aboveViewport);
        });
      }, { threshold: 0 });
      io.observe(actions);
    }
    var stickyAdd = bar.querySelector('[data-buono-sticky-add]');
    var mainAdd = root.querySelector('[data-buono-add]');
    if (stickyAdd && mainAdd) {
      stickyAdd.addEventListener('click', function () { mainAdd.click(); });
    }
  }

  function initUrgency(root) {
    /* Cuenta atrás real hacia la hora de corte; viewers ilustrativo estable */
    var cd = root.querySelector('[data-buono-countdown]');
    var cdAlt = root.querySelector('[data-buono-countdown-alt]');
    if (cd && cdAlt) {
      var cut = parseInt(cd.getAttribute('data-cutoff-hour'), 10);
      if (!isNaN(cut)) {
        var now = new Date();
        if (now.getHours() >= cut) { cd.hidden = true; cdAlt.hidden = false; }
      }
    }
  }

  function initProduct(root) {
    if (root.dataset.buonoReady) return;
    root.dataset.buonoReady = '1';
    initGallery(root);
    initGalleryScroller(root);
    initVariants(root);
    initQty(root);
    initGift(root);
    initSticky(root);
    initUrgency(root);
  }

  function init() {
    document.querySelectorAll('[data-buono-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
